import React from 'react'

import T from 'components/FormattedMessage'
import MatchStatusSwitch from 'components/MatchStatusSwitch'

import { IMatchEvent, IPlayer, IMatch } from 'protos'

import BaseGameStatusBar from './components/LastEventBar/components/BaseGameStatusBar'
import LastEventBar from './components/LastEventBar'

interface Props {
  match: IMatch
  onClick?: () => void
  events?: Array<IMatchEvent> | null
  players?: { [k: string]: IPlayer } | null
}

const GameStatusBar: React.SFC<Props> = ({ match, events, players, onClick }) => (
  <MatchStatusSwitch
    status={match.status}
    renderPreMatch={() => (
      <BaseGameStatusBar
        disableArrow
        color="secondary"
        headline={<T id="eventbar_empty_title" />}
        message={<T id="eventbar_empty_message" />}
        onClick={onClick}
      />
    )}
    renderPostMatch={() => (
      <BaseGameStatusBar
        color="secondary"
        headline={<T id="eventbar_finished_title" />}
        message={<T id="eventbar_finished_message" />}
        onClick={onClick}
      />
    )}
    renderDuringMatch={() => (
      <LastEventBar
        match={match}
        events={events}
        players={players}
        onClick={onClick}
      />
    )}
  />
)

export default GameStatusBar
